export default "__VITE_PUBLIC_ASSET__3f817f23__"